<table class="table table-striped m-0">
  @if (haveMultiActions) {
    <thead>
      <tr>
        @if (haveMultiActions) {
          <th scope="col"></th>
        }
        @for (col of columns; track $index) {
          @if (col.type !== 'hidden') {
            <th scope="col">
              {{ col.label }}
            </th>
          }
        }
      </tr>
    </thead>
  }
  <tbody>
    @for (n of [1, 2, 3]; track n) {
      <tr class="datagrid__row">
        @if (haveMultiActions) {
          <td class="px-1">
            <div class="form-check d-flex justify-content-center">
              <input name="checkbox" type="checkbox" class="form-check-input" disabled i18n-aria-label
                aria-label="Checkbox is disabled" />
            </div>
          </td>
        }
        @for (col of columns; track col) {
          @if (col.type !== 'hidden') {
            <td>
              <p class="placeholder-wave">
                <span class="placeholder" [style.width]="getPlaceholderWidth(col.type)"></span>
              </p>
            </td>
          }
        }
      </tr>
    }
  </tbody>
</table>